import script from "./appHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./appHeader.vue?vue&type=script&setup=true&lang=js"

import "./appHeader.vue?vue&type=style&index=0&id=535781bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535781bb"]])

export default __exports__